const initDrawer = () => {
  const body = document.body
  const megamenuItems = document.querySelectorAll(".megamenu-item")
  const drawerIcon = document.querySelector("#drawer-icon")
  const closeDrawerIcon = document.querySelector("#close-drawer-icon")

  // create a wrapper for inline display
  const wrapper = document.createElement("div")
  wrapper.classList.add(
    "hidden",
    "w-full",
    "lg:flex!",
    "justify-around",
    "lg:relative",
    "absolute",
    "top-[60px]",
    "lg:top-0",
    "left-0",
    "h-[calc(100dvh-95.5px)]",
    "lg:h-fit",
    "bg-white",
    "z-10",
    "overflow-y-scroll",
    "lg:overflow-y-visible",
    "pb-4",
    "lg:pb-0",
    "border-y",
    "border-edena-greylight",
  )

  for (const item of megamenuItems) {
    wrapper.appendChild(item)
    item.querySelector(".megamenu-inner-item").classList.remove("hidden")
    item.querySelector(".megamenu-menuitem").addEventListener("click", () => {
      if (window.screen.width < 896) {
        const subItems = item.querySelector(".megamenu-subitems")
        subItems.classList.toggle("hidden")
      }
    })
  }

  // append the wrapper to the body after header
  const header = document.querySelector("header")
  header.parentNode.insertBefore(wrapper, header.nextSibling)

  // mobile drawer
  drawerIcon.addEventListener("click", () => {
    wrapper.classList.remove("hidden")
    drawerIcon.classList.add("hidden")
    closeDrawerIcon.classList.remove("hidden")
    body.style.overflow = "hidden"
  })

  closeDrawerIcon.addEventListener("click", () => {
    wrapper.classList.add("hidden")
    drawerIcon.classList.remove("hidden")
    closeDrawerIcon.classList.add("hidden")
    body.style.overflow = "auto"
  })
}

window.initDrawer = initDrawer
document.addEventListener("DOMContentLoaded", initDrawer)
